import PropTypes from 'prop-types';
import classes from './InfoList.module.scss';

const CopyIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
        <path
            fill="#63499D"
            fillRule="evenodd"
            d="M7.963 2.834h2.074c.911 0 1.646 0 2.224.078.6.08 1.106.253 1.507.654s.574.907.654 1.507c.078.578.078 1.313.078 2.224v3.407c0 .912 0 1.646-.078 2.224-.08.6-.253 1.106-.654 1.507-.402.401-.907.574-1.507.655-.578.077-1.313.077-2.224.077H7.963c-.911 0-1.646 0-2.224-.077-.6-.081-1.105-.254-1.507-.655s-.574-.906-.654-1.507C3.5 12.35 3.5 11.617 3.5 10.705V7.297c0-.911 0-1.646.078-2.224.08-.6.253-1.106.654-1.507.402-.401.907-.574 1.507-.654.578-.078 1.313-.078 2.224-.078m-2.09 1.069c-.49.066-.75.186-.934.37-.184.185-.304.444-.37.933C4.5 5.71 4.5 6.377 4.5 7.334v3.333c0 .957.001 1.625.069 2.128.066.49.186.749.37.933.185.184.444.305.933.37.504.068 1.171.07 2.128.07h2c.957 0 1.624-.002 2.128-.07.49-.065.748-.186.933-.37.184-.184.305-.444.37-.933.068-.503.069-1.17.069-2.128V7.334c0-.957-.001-1.624-.069-2.128-.065-.49-.186-.748-.37-.933-.185-.184-.444-.304-.933-.37-.504-.068-1.171-.069-2.128-.069H8c-.957 0-1.624.001-2.128.069"
            clipRule="evenodd"
        />
        <path
            fill="#63499D"
            fillRule="evenodd"
            d="M7.296.834H10a2.5 2.5 0 0 1 2.5 2.5h-1a1.5 1.5 0 0 0-1.5-1.5H7.333c-1.27 0-2.174.001-2.86.093-.67.09-1.056.26-1.338.542s-.452.668-.542 1.339c-.092.685-.093 1.588-.093 2.86v4a1.5 1.5 0 0 0 1.5 1.5v1a2.5 2.5 0 0 1-2.5-2.5V6.63c0-1.225 0-2.196.102-2.955.105-.782.327-1.415.826-1.914s1.131-.72 1.913-.825C5.1.834 6.07.834 7.296.834"
            clipRule="evenodd"
            opacity={0.5}
        />
    </svg>
);

const InfoRow = ({ label = '', value = '', isCopyable = false, onCopy }) => {
    const handleCopy = () => {
        if (onCopy) {
            onCopy(value);
        } else if (navigator.clipboard) {
            navigator.clipboard.writeText(value);
        }
    };

    return (
        <div className={classes.infoRow}>
            <p className={classes.infoRow__key}>{label}</p>
            <p className={classes.infoRow__value}>
                {value}
                {isCopyable && (
                    <CopyIcon
                        role="button"
                        tabIndex={0}
                        aria-label={`Copy ${label}`}
                        className={classes.infoRow__copyIcon}
                        onClick={handleCopy}
                        onKeyDown={(e) => e.key === 'Enter' && handleCopy()}
                    />
                )}
            </p>
            <hr className={classes.infoRow__divider} />
        </div>
    );
};

const InfoList = ({ data = [], onCopy }) => {
    const infoArray = Array.isArray(data) ? data : [];

    return (
        <div className={classes.infoList}>
            {infoArray
                .filter((item) => {
                    const val = item.value;
                    return val !== null && val !== undefined && String(val).trim() !== '';
                })
                .map((item) => (
                    <InfoRow
                        key={item.label}
                        label={item.label}
                        value={item.value}
                        isCopyable={item.isCopyable}
                        onCopy={onCopy}
                    />
                ))}
        </div>
    );
};

InfoList.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            isCopyable: PropTypes.bool,
        }),
    ),
    onCopy: PropTypes.func,
};

InfoRow.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isCopyable: PropTypes.bool,
    onCopy: PropTypes.func,
};

export default InfoList;
